export const handleImageBase64 = (thumbnail) => {
  let image_src = JSON.stringify({
    "bucket": "wa10x.v2",
    "key": `${thumbnail}`,
    "edits": {
      "resize": {
        "width": 600,
        "height": 600,
        "fit": "cover"
      },
      "rotate": null,
    }
  })

  return image_src;
}